import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { NotificationSignalTypes } from 'applications/signal/constants';

export type BrandSignalSample = {
  entityLabel: string;
  brandName: string;
  minThreshold: number;
  maxThreshold: number;
}

type Props = {
  signalType: number;
  samples: BrandSignalSample[];
}

const BRAND_NAME_ROW_COLOR = '#f5f5f5';
const ENTITY_LABEL_ROW_COLOR = '#e0e0e0';

export default function BrandSignalSampleList({ signalType, samples }: Props) {
  function sampleDisplayValue(value: number) {
    if ([NotificationSignalTypes.SalesAmount.ordinal, NotificationSignalTypes.SalesQuantity.ordinal].includes(signalType)) {
      return `${Math.round(value)}`;
    }
    return `${Math.round(value * 100) / 100}%`;
  }

  return (
    <>
      <Box sx={{ maxWidth: 600, mx: "auto" }}>
        <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
          参考値リスト
        </Typography>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ border: 'none' }}></TableCell>
              {
                samples.map((sample, index) => (
                  <TableCell key={`entityLabel-${index}`} sx={{ textAlign: 'right', backgroundColor: ENTITY_LABEL_ROW_COLOR }}>
                    {sample.entityLabel}
                  </TableCell>
                ))
              }
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              {
                samples.map((sample, index) => (
                  <Tooltip
                    key={`brandNameTooltip-${index}`}
                    title={sample.brandName}
                    enterDelay={500}
                    arrow
                    placement="top"
                  >
                    <TableCell
                      key={`brandName-${index}`}
                      sx={{
                        backgroundColor: BRAND_NAME_ROW_COLOR,
                        maxWidth: 120,
                        textAlign: 'right',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {sample.brandName}
                    </TableCell>
                  </Tooltip>
                ))
              }
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell sx={{ textAlign: 'center', backgroundColor: ENTITY_LABEL_ROW_COLOR }}>最大</TableCell>
              {
                samples.map((sample, index) => (
                  <TableCell key={`maxThreshold-${index}`} sx={{ textAlign: 'right', backgroundColor: 'white !important' }}>
                    {sampleDisplayValue(sample.maxThreshold)}
                  </TableCell>
                ))
              }
            </TableRow>
            <TableRow>
              <TableCell sx={{ textAlign: 'center', backgroundColor: `${ENTITY_LABEL_ROW_COLOR} !important` }}>最小</TableCell>
              {
                samples.map((sample, index) => (
                  <TableCell key={`minThreshold-${index}`} sx={{ textAlign: 'right', backgroundColor: 'white !important' }}>
                    {sampleDisplayValue(sample.minThreshold)}
                  </TableCell>
                ))
              }
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
